import EYValidation from './eyValidation';

export const schema = {
	addedById: EYValidation.string().required(),

	clientId: EYValidation.number().integer(),

	clientCode: EYValidation.string()
		.trim()
		.max(50)
		.required(),

	emailAddress: EYValidation.string().required(),
	engagementId: EYValidation.number(),
	engagements: EYValidation.array(),
	engagementCode: EYValidation.string().required(),
	engagementCodes: EYValidation.array(),
	engagementTypeId: EYValidation.string().required(),

	firstName: EYValidation.string().required(),

	id: EYValidation.string().required(),

	lastName: EYValidation.string().required(),

	name: EYValidation.string()
		.trim()
		.max(500)
		.required(),

	percentage: EYValidation.number()
		.positive()
		.decimal(2),

	projectId: EYValidation.string(),

	rate: EYValidation.number()
		.min(0)
		.integer(),

	searchString: EYValidation.string(),
	system: EYValidation.string().required(),

	userGui: EYValidation.string().required(),
	users: EYValidation.object().required(),

	workspaceId: EYValidation.number().integer(),

	engagementDetails: EYValidation.object(),
	userRoleId: EYValidation.number().required()
};
